module.exports = __webpack_public_path__ + "images/emoji/closed_book.ca3bfc24b3c209911b1a.png";